/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistorySocialHistoryViewerAliases {
  ACTION_INACTIVATE_HEALTH_HISTORY_SOCIAL_HISTORY = 'action-inactivate-health-history-social-history',
  ACTION_NEW_HEALTH_HISTORY_SOCIAL_HISTORY = 'action-new-health-history-social-history',
  ACTION_REVIEW_HEALTH_HISTORY_SOCIAL_HISTORY = 'action-review-health-history-social-history',
  CHECKBOX_DENIES_HABITS = 'checkbox-denies-habits',
  CHECKBOX_DISPLAY_PATIENT_ALERTS = 'checkbox-display-patient-alerts',
  CHECKBOX_INSERT_LIST_PROBLEMS = 'checkbox-insert-list-problems',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_AGE_EXPERIENCE = 'field-age-experience',
  FIELD_AGE_REGULAR_USE = 'field-age-regular-use',
  FIELD_BRAND = 'field-brand',
  FIELD_CLASSIFICATION = 'field-classification',
  FIELD_CONDITION = 'field-condition',
  FIELD_CONSEQUENCES = 'field-consequences',
  FIELD_DENIES_HABITS = 'field-denies-habits',
  FIELD_DESCRIPTIVE_QUANTITY = 'field-descriptive-quantity',
  FIELD_DISPLAY_PATIENT_ALERTS = 'field-display-patient-alerts',
  FIELD_DURATION = 'field-duration',
  FIELD_END_DATE = 'field-end-date',
  FIELD_FAMILY_ANTECEDENTS = 'field-family-antecedents',
  FIELD_FREQUENCY = 'field-frequency',
  FIELD_INSERT_LIST_PROBLEMS = 'field-insert-list-problems',
  FIELD_NOTES = 'field-notes',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_QUANTITY = 'field-quantity',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_REVIEW_DATE = 'field-review-date',
  FIELD_REVIEW_USERNAME = 'field-review-username',
  FIELD_SECURITY_LEVEL = 'field-security-level',
  FIELD_START_DATE = 'field-start-date',
  FIELD_TOTAL_PACKS = 'field-total-packs',
  FIELD_TYPE = 'field-type',
  FIELD_UNIT_MEASURE = 'field-unit-measure',
  FORM_HEALTH_HISTORY_SOCIAL_HISTORY_VIEWER = 'form-health-history-social-history-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_HEALTH_HISTORY_SOCIAL_HISTORY_VIEWER = 'layout-health-history-social-history-viewer',
  PANEL_FORM = 'panel-form',
  RADIO_GROUP_CONDITION = 'radio-group-condition',
  TEXT_AGE_EXPERIENCE = 'text-age-experience',
  TEXT_AGE_REGULAR_USE = 'text-age-regular-use',
  TEXT_AREA_NOTES = 'text-area-notes',
  TEXT_BRAND = 'text-brand',
  TEXT_CLASSIFICATION = 'text-classification',
  TEXT_CONSEQUENCES = 'text-consequences',
  TEXT_DESCRIPTIVE_QUANTITY = 'text-descriptive-quantity',
  TEXT_DURATION = 'text-duration',
  TEXT_END_DATE = 'text-end-date',
  TEXT_FAMILY_ANTECEDENTS = 'text-family-antecedents',
  TEXT_FREQUENCY = 'text-frequency',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_QUANTITY = 'text-quantity',
  TEXT_RECORD_DATE = 'text-record-date',
  TEXT_REVIEW_DATE = 'text-review-date',
  TEXT_REVIEW_USERNAME = 'text-review-username',
  TEXT_SECURITY_LEVEL = 'text-security-level',
  TEXT_START_DATE = 'text-start-date',
  TEXT_TOTAL_PACKS = 'text-total-packs',
  TEXT_TYPE = 'text-type',
  TEXT_UNIT_MEASURE = 'text-unit-measure',
}
export { HealthHistorySocialHistoryViewerAliases };
